// Tiny synthesized click sound (Web Audio API, no asset file) — a short,
// soft blip for copy-to-clipboard confirmations. Generated, not licensed
// audio, so there's nothing to source or attribute.
let ctx: AudioContext | null = null;

export function playClickSound() {
  try {
    if (!ctx) ctx = new (window.AudioContext || (window as any).webkitAudioContext)();
    if (ctx.state === "suspended") ctx.resume();

    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = "sine";
    osc.frequency.setValueAtTime(880, ctx.currentTime);
    osc.frequency.exponentialRampToValueAtTime(660, ctx.currentTime + 0.08);
    gain.gain.setValueAtTime(0.12, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.1);
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.start();
    osc.stop(ctx.currentTime + 0.1);
  } catch {
    // Audio can fail silently (autoplay policy, unsupported browser) —
    // the copy itself still works, sound is just a nice-to-have.
  }
}
